import { render, staticRenderFns } from "./FileSystemTag.vue?vue&type=template&id=3bb09106&scoped=true&"
import script from "./FileSystemTag.vue?vue&type=script&lang=js&"
export * from "./FileSystemTag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bb09106",
  null
  
)

export default component.exports